import getMembershipProperties from './getMembershipProperties'
import isEnterpriseAdmin from './isEnterpriseAdmin'

export default function isEnterpriseUser() {
  const { originatorType } = getMembershipProperties()
  const isEnterpriseSubscription = originatorType === 'EnterpriseSubscription'
  return isEnterpriseAdmin() || isEnterpriseSubscription
}
